export const ERROR_MESSAGE = {
  INVALID_USER_TYPE: '利用者側のURLで再度お試しください。',
  INVALID_USER_TYPE_ADMIN: '管理者側のURLで再度お試しください。',
  TOKEN_EXPIRED: '認証の有効期限が切れました。再ログインしてください。',
};
